import { Modal } from '@client/new/components/Modal/Modal';
import { PrimaryButton } from '@client/new/components/button';

import { EditParams } from '../videos/videos.model';
import MediaThumbnailSelect from '../videos/components/MediaThumbnailSelect';
import { Step } from './useExerciseUpload';
import { MediaFileValidation } from './MediaFileValidation';

export type MediaUploadModalProps = {
  isOpen: boolean;
  onClose: () => void;
  media: File;
  onUpload: (p: { file: File; editParams?: EditParams }) => void;
  onCancel: () => void;
  onSaveThumbnail: (time: number) => void;
  selectVideo: (file: File) => void;
  onValidationSuccess: () => void;
  step: Step;
  editParams?: EditParams;
};

const getTitle = (step: Step) => {
  if (step === 'validate') {
    return 'Video validation';
  }
  return 'Change thumbnail';
};

export function MediaUploadModal(p: MediaUploadModalProps) {
  const upload = () => {
    p.onUpload({ file: p.media, editParams: p.editParams });
    p.onClose();
  };

  return (
    <Modal
      title={getTitle(p.step)}
      height="auto"
      sx={{
        maxWidth: { sm: '100vw', md: 850, lg: 850 },
        maxHeight: { sm: '100vh', md: '100vh', lg: '100vh' },
        width: { sm: '100vw', md: '850px !important', lg: '850px !important' },
      }}
      isOpen={p.isOpen}
      onClose={p.onClose}
      disableBackdropClick={true}
      titleVariant="h4"
    >
      <>
        {p.step === 'validate' ? (
          <MediaFileValidation
            media={p.media}
            videoType={'short'}
            addVideo={p.selectVideo}
            onValidationSuccess={p.onValidationSuccess}
          />
        ) : (
          <>
            <MediaThumbnailSelect
              media={p.media}
              onChange={p.onSaveThumbnail}
              width={790}
              height={79}
              ratio={9 / 16}
              startTime={p.editParams?.startTime}
              endTime={p.editParams?.endTime}
            />
            <div className="flex justify-end">
              <div className="flex gap-4">
                <PrimaryButton onClick={upload}>Save</PrimaryButton>
              </div>
            </div>
          </>
        )}
      </>
    </Modal>
  );
}
